import MsisdnForm from '@/components/Authentication/LoginForms/MsisdnForm.vue';
import UsernameForm from '@/components/Authentication/LoginForms/UsernameForm.vue';
import SmsForm from '@/components/Authentication/LoginForms/SmsForm.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { mapActions, mapGetters } from 'vuex';
import localStorage from '@/components/Services/storage';
import { RESEND_COUNTDOWN_DURATION, SMS_STATE_KEY } from '@/constants/auth';

export default {
    data() {
        return {
            msisdnLoginMethodActive: true,
            usernameLoginMethodActive: false,
        };
    },

    components: {
        MsisdnForm,
        UsernameForm,
        SmsForm,
        LanguageSwitcher
    },

    methods: {
        ...mapActions('user', ['restoreSmsState']),
        /**
         * Toggles the msisdnLoginMethodActive property
         *
         * @return  {void}
         */
        toggleActiveParameter(type) {
            this.user.error = '';

            if (type === 'msisdn') {
                this.msisdnLoginMethodActive = true;
                this.usernameLoginMethodActive = false;
                // Restore SMS state if user switches back to MSISDN tab
                this.checkAndRestoreSmsState();
                return;
            }
            this.msisdnLoginMethodActive = false;
            this.usernameLoginMethodActive = true;
            // After sms is sent and user choose another method rather then sms login,
            // then set sms to false and show him another method that is chosen
            this.user.isSmsCodeSent = false;
        },
        /**
         * Restore SMS state from localStorage on page refresh
         *
         * @return  {void}
         */
        checkAndRestoreSmsState() {
            const smsStateStr = localStorage.get(SMS_STATE_KEY, true);

            if (smsStateStr) {
                try {
                    const smsState = JSON.parse(smsStateStr);

                    // Only restore if SMS was sent and countdown hasn't fully expired
                    if (smsState.codeSent && smsState.userId && smsState.lastSentTime) {
                        const elapsedSeconds = Math.floor((Date.now() - smsState.lastSentTime) / 1000);
                        // Prefer phone from smsState; fall back to legacy separate key
                        const phoneNumber = smsState.phone || localStorage.get('phone', true);

                        // If countdown hasn't expired, restore the SMS form state
                        if (elapsedSeconds < RESEND_COUNTDOWN_DURATION) {
                            this.restoreSmsState({
                                userId: smsState.userId,
                                isSmsCodeSent: true,
                                phoneNumber: phoneNumber,
                            });
                        } else {
                            // Countdown expired, clear the stored state
                            localStorage.remove(SMS_STATE_KEY);
                        }
                    }
                } catch (e) {
                    // Invalid JSON, clear corrupted data
                    console.error('Failed to parse SMS state:', e);
                    localStorage.remove(SMS_STATE_KEY);
                }
            }
        },
        /**
         * Go back to phone number form and reset SMS state
         *
         * @return  {void}
         */
        goBackToPhoneForm() {
            // Keep SMS_STATE_KEY in localStorage so countdown can be restored
            // if the user re-enters the same phone number

            // Reset Vuex state
            this.user.isSmsCodeSent = false;
            this.user.userId = null;
            this.user.validation_errors.code = [];
        },
    },

    mounted() {
        // Restore SMS state on component mount (page refresh)
        this.checkAndRestoreSmsState();
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
            locale: 'locale',
            brand: 'brand'
        }),
    }
};
